import { render } from "./MemberMessages.vue?vue&type=template&id=d7238636&scoped=true&ts=true&lang=pug"
import script from "./MemberMessages.vue?vue&type=script&lang=ts"
export * from "./MemberMessages.vue?vue&type=script&lang=ts"

import "./MemberMessages.vue?vue&type=style&index=0&id=d7238636&lang=scss&scoped=true"

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7238636"]])

export default __exports__